import React, { Component } from 'react';
import { stateTitle, zipTitle } from '../HeaderTopContainer';

class SearchStoreLocationControls extends Component {
  render() {
    const { storesForZip, callForSearchStores, storesForState } = this.props;

    const activeStyles = {
      color: '#e10098',
      borderBottom: '1px solid #e10098',
    };

    const inactiveStyles = {
      color: 'initial',
      borderBottom: '1px solid #d8d8d8',
    };

    return (
      <div className="searchStoreLocationControls alignmentRow">
        <button
          className={'resetDefaultStyleBtn'}
          onClick={() => callForSearchStores(zipTitle)}
          style={storesForZip ? activeStyles : inactiveStyles}
        >
          { zipTitle }
        </button>

        <button
          className={'resetDefaultStyleBtn'}
          onClick={() => callForSearchStores(stateTitle)}
          style={storesForState ? activeStyles : inactiveStyles}
        >
          { stateTitle }
        </button>
      </div>
    );
  }
}

export default SearchStoreLocationControls;
